<template>
  <div id="app">
    <router-view></router-view>
    <object class="obj-footer" :data="`/web/Common/snippet/footer.html?json=${encodeURIComponent(JSON.stringify(footer))}`"></object>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      footer: {
        contacts: [
          {
            "name": "网站咨询",
            "value": [
              "010-55579309"
            ]
          },
          {
            "name": "技术支持",
            "value": [
              "010-67800498"
            ]
          }
        ]
      }
    }
  }
}
</script>

<style>
*{
  margin: 0px;
  padding: 0px;
  list-style: none;
  text-decoration: none;
}
html,body,#app{
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.amap-icon img{
  width: 25px !important;
  height: 34px !important;
  left: 0;
}
.obj-footer {
  width: 100%;
  height: 266px;
}
</style>
